import React from "react";
import SectionCommonTable from "../../components/SectionCommonTable";
import RoiBonusTable from "./Table/roiBonusTable";

const RoiBonusPage = () => {
  return (
    <SectionCommonTable
      wrapperClassName="roibonus_table"
      cardStyle={{ backgroundColor: "#fff" }}
      sectionTableTitle="ROI Bonus"
      table={<RoiBonusTable />}
    />
  );
};

export default RoiBonusPage;
